<ng-template #toolbarTemplate>
    <grid-assigned-to-id-filter
        title="Assigned to Me"
        [field]="assignedToField"
        [assignToId]="userId"
        [filter]="grid.filter"
        [filterService]="grid.filterService"
        (filterValueChanged)="onChangeFilter($event)">
    </grid-assigned-to-id-filter>


    <grid-assigned-to-id-filter
        title="Hide Contract Requested"
        field="hideContractRequested"
        [assignToValue]="true"
        [filter]="grid.filter"
        [filterService]="grid.filterService"
        (filterValueChanged)="onChangeFilter($event)">
    </grid-assigned-to-id-filter>


    <grid-assigned-to-id-filter
        title="Hide Rescinded/Declined"
        field="hideDeclinedAndRescinded"
        [assignToValue]="true"
        [filter]="grid.filter"
        [filterService]="grid.filterService"
        (filterValueChanged)="onChangeFilter($event)">
    </grid-assigned-to-id-filter>
</ng-template>

<nova-grid #grid
           [args]="args"
           [data]="gridData"
           [isLoading]="isLoading"
           [resizable]="true"
           [filterable]="true"
           (dataNeeded)="load($event)"
           (dataStateChange)="dataGridChanged($event)"
           [toolbarTemplate]="toolbarTemplate"
           [rowClassCallback]="rowClass"
           [autoFitColumns]="autoFitColumnsVal">
    <nova-grid-column field="agencyName" title="Agency" [template]="agencyTemplate" [sortable]="true" filterType="text" *ngIf="userType !== offersUserType.Recruiter">
        <ng-template #agencyTemplate let-dataItem="dataItem">
            <div class="agency-label">{{ dataItem.agencyName }}</div>
            <div class="agency-label">{{ dataItem.vendorContactName }}</div>
            <div><a class="mailTo-link" href="mailto:{{ dataItem.vendorContactEmail }}">{{ dataItem.vendorContactEmail }}</a></div>
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="id" title="Actions" [template]="actionTemplate">
        <ng-template #actionTemplate let-dataItem="dataItem">
            <span class="nova__link viewDetails-link" (click)="viewDetails(dataItem.id)">View Details</span>
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="contractType" title="Contract Type" [sortable]="true">
    </nova-grid-column>
    <nova-grid-column field="candidateName" title="Candidate Name" [sortable]="true" [template]="candidateNameTemplate" filterType="text" width="160">
        <ng-template #candidateNameTemplate let-dataItem="dataItem">
            <span *ngIf="hyperLinkCandidate && dataItem.candidateId; else candidateText">
                <span (click)="candidateClick(dataItem.candidateId)" class="nova__link candidateName-link">{{ dataItem?.candidateName }}</span>
            </span>

            <ng-template #candidateText>
                <span>{{ dataItem?.candidateName }}</span>
            </ng-template>
        </ng-template>
    </nova-grid-column>

    <nova-grid-column field="readyForVerballyAccepted" title="Offer Verbally Accepted" [sortable]="false" [template]="verballyAcceptTemplate">
        <ng-template #verballyAcceptTemplate let-dataItem="dataItem">
            <button mat-raised-button
                    *ngIf="dataItem.readyForVerballyAccepted"
                    class="button-verbally-accept"
                    aria-label="Button to share offer as verbally accepted"
                    data-qa-id="verbally_accept_button"
                    [matTooltip]="dataItem.offerVerballyAccepted ? 'This offer has been shared as verbally accepted' : 'Share that this offer has been verbally accepted'"
                    [disabled]="dataItem.offerVerballyAccepted"
                    (click)="verballyAcceptOffer(dataItem)">
                {{dataItem.offerVerballyAccepted ? 'ACCEPTED' : 'ACCEPT'}}
            </button>
        </ng-template>
    </nova-grid-column>

    <nova-grid-column field="jobId" title="Job Id" [sortable]="true" filterType="text" [template]="jobIdTemplate">
        <ng-template #jobIdTemplate let-dataItem="dataItem">
            <span routerLink="/recruiting/jobs/{{ dataItem.jobId }}" class="nova__link">{{dataItem?.jobId}}</span>
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="marginId" title="Margin Id" [sortable]="true" filterType="text" [template]="marginIdTemplate">
        <ng-template #marginIdTemplate let-dataItem="dataItem">
            <a class="nova__link" target="_blank"
               routerLink="/margin-calculator/{{userId}}/margin/{{dataItem.marginId}}">
                {{dataItem.marginId}}
            </a>
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="facilityName"
                      title="Facility"
                      [sortable]="true"
                      [template]="facilityIdTemplate"
                      filterType="text">
        <ng-template #facilityIdTemplate let-dataItem="dataItem">
            <span (click)="openFacility(dataItem.facilityId)" class="nova__link facilityName-link">{{ dataItem?.facilityName }}</span>
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="profession"
                      title="Profession"
                      [sortable]="true"
                      filterType="dropdown"
                      defaultItemText="All Professions"
                      textField="name"
                      valueField="id"
                      [filterOptions]="lookupProfessions">
    </nova-grid-column>
    <nova-grid-column field="expertise"
                      title="Specialty"
                      [sortable]="true"
                      filterType="dropdown"
                      defaultItemText="All Specialties"
                      textField="name"
                      valueField="searchableVal"
                      [filterOptions]="lookupExpertise">
    </nova-grid-column>
    <nova-grid-column field="startDate" title="Start Date" [sortable]="true" [template]="startDateTemplate">
        <ng-template #startDateTemplate let-dataItem="dataItem">
            {{ dataItem.startDate | date: 'MM/dd/yyyy' }}
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="facilityRate" title="Facility Bill Rate" [template]="facilityRateTemplate" [sortable]="true">
        <ng-template #facilityRateTemplate let-dataItem="dataItem">
            {{ dataItem.facilityRate | currency }}
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="accountManagerId"
                      title="AM"
                      [template]="accountManagerFieldTemplate"
                      [sortable]="true"
                      filterType="multiselect"
                      textField="name"
                      valueField="id"
                      [filterOptions]="accountManagerValues">
        <ng-template #accountManagerFieldTemplate let-dataItem="dataItem">
            {{ dataItem.accountManagerName }}
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="offerStatus"
                      [title]="userType !== offersUserType.Recruiter ? 'Status' : 'Offer Status'"
                      [sortable]="true"
                      filterType="multiselect"
                      textField="name"
                      valueField="id"
                      [filterOptions]="filteredStatuses">
    </nova-grid-column>
    <nova-grid-column field="updatedDateUtc"
                      title="Offer Status Date"
                      [sortable]="true"
                      [template]="contractRequestStatusTemplate"
                      *ngIf="userType === offersUserType.Recruiter">
        <ng-template #contractRequestStatusTemplate let-dataItem="dataItem">
            {{ dataItem.updatedDateUtc | date: 'MM/dd/yyyy hh:mm a' | lowercase }}
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="contractRequestStatus"
                      title="Contract Request Status"
                      [sortable]="true"
                      [template]="contractRequestStatusTemplate"
                      filterType="multiselect"
                      textField="name"
                      valueField="id"
                      [filterOptions]="contractReqStatuses"
                      *ngIf="userType === offersUserType.Recruiter">
        <ng-template #contractRequestStatusTemplate let-dataItem="dataItem">
            {{ dataItem.contractRequestStatusText }}
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="contractRequestStatusUpdatedDate" title="Contract Requested Date" [sortable]="true" [template]="requestedDateTemplate" *ngIf="userType === offersUserType.Recruiter">
        <ng-template #requestedDateTemplate let-dataItem="dataItem">
            {{ dataItem.contractRequestStatusUpdatedDate | date: 'MM/dd/yyyy hh:mm a' | lowercase }}
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="contractStageId"
                      title="Contract Status"
                      [sortable]="true"
                      [template]="contractStageTemplate"
                      filterType="multiselect"
                      textField="name"
                      valueField="id"
                      [filterOptions]="contractStages"
                      *ngIf="userType === offersUserType.Recruiter">
        <ng-template #contractStageTemplate let-dataItem="dataItem">
            {{ dataItem.contractStageText }}
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="contractStageUpdatedDate" title="Contract Date" [sortable]="true" [template]="contractStageUpdatedDateTemplate" *ngIf="userType === offersUserType.Recruiter">
        <ng-template #contractStageUpdatedDateTemplate let-dataItem="dataItem">
            {{ dataItem.contractStageUpdatedDate | date: 'MM/dd/yyyy hh:mm a' | lowercase }}
        </ng-template>
    </nova-grid-column>
    <nova-grid-column field="createdDate" title="Created Date" [sortable]="true" [template]="createdDateTemplate" *ngIf="userType !== offersUserType.Recruiter">
        <ng-template #createdDateTemplate let-dataItem="dataItem">
            {{ dataItem.createdDate | date: 'MM/dd/yyyy hh:mm a' | lowercase }}
        </ng-template>
    </nova-grid-column>
</nova-grid>
